import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';
import { CountryService } from 'src/app/country.service';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {
  country = 'sg';
  constructor(private meta: Meta, private title: Title, private cs: CountryService, private canonicalService: CanonicalService) {
  }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
    if (this.country === 'sg') {
      this.title.setTitle("Terms of Use - SingX");
      this.canonicalService.updateCanonicalUrl('/terms-of-use');
      this.meta.updateTag({ name: 'description', content: 'SingX helps to transfer Fund globally for Personal or business use. Protecting your privacy is very important to SingX. Transfer money securely overseas without any hidden charges.' })
      this.meta.updateTag({ name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
    } else if (this.country === 'hk') {
      this.title.setTitle("Terms of Use | SingX");
      this.canonicalService.updatehkCanonicalUrl('/terms-of-use');
      this.meta.updateTag({name: 'description', content: 'Transfer Money from Hong Kong to any other Country with SingX by using our Terms and Conditions. We are Payment Service Provider and works with Licensed Remittance Operators.' })
      this.meta.updateTag({name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Money Transfer from Hong Kong, Money Transfer Overseas, Money Transfer Globally, International Money Transfer, International Business Payment, Fund Transfer Overseas, International Remittance, Money Exchangers'})
    } else if(this.country === 'au'){

      this.title.setTitle("Terms of Use | SingX");
      this.canonicalService.updateauCanonicalUrl('/terms-of-use');
      this.meta.updateTag({name: 'description', content: 'Transfer Money from Australia to any other Country with SingX by using our Terms and Conditions. For More details get in Touch with us.' })
      this.meta.updateTag({name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'International Money Transfer from Australia, Money Transfer Overseas, Global Money Transfer, International Fund Transfer, International Remittance, Remit Money Overseas, Foreign Remittance, International Payment Transfer.'})
    } else {
      this.title.setTitle("Terms of Use - SingX");
      this.meta.addTags([
        { name: 'description', content: 'SingX helps to transfer Fund globally for Personal or business use. Protecting your privacy is very important to SingX. Transfer money securely overseas without any hidden charges.' },
        { name: 'author', content: 'SingX' },
        { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
      ], true);
    }
  }

}
